import { createContext, FC, ReactElement, useCallback, useContext, useState } from 'react'
import { get as getLabs, Lab } from '../../externals/api/labs'
import { useAlertHandler } from '../alertHandler'

interface ILabs {
  labs: Lab[];
  get: () => Promise<Lab[]>;
}

const LabsContext = createContext<ILabs>({} as ILabs)

export const useLabs = (): ILabs => {
  const context = useContext(LabsContext)
  if (!context) {
    throw new Error('useProcessExam must be used within an ProcessExamContext')
  }

  return context
}

export const LabsProvider: FC = ({ children }): ReactElement => {
  const [labs, setLabs] = useState<Lab[]>([])
  const { showError } = useAlertHandler()

  const get = useCallback(async (): Promise<Lab[]> => {
    try {
      const response = await getLabs()
      setLabs(response)

      return response
    } catch (err) {
      showError(err)

      throw err
    }
  }, [setLabs, showError])

  return (
    <LabsContext.Provider
      value={{
        labs,
        get
      }}
    >
      {children}
    </LabsContext.Provider>
  )
}
